import {z} from 'zod';
import {ShareLinkSchema} from '../shareLink';

/** a stripped down version of the token link */
export const ShareLinkInfoSchema = ShareLinkSchema.pick({
	assetCount: true,
	attributeIds: true,
	creationDate: true,
	expirationDate: true,
	options: true,
	passwordProtected: true,
	title: true,
	// token: true,
	type: true,
}).extend({
	token: z.string(),
});

/** a stripped down version */
export type IShareLinkInfo = z.infer<typeof ShareLinkInfoSchema>;
